import React from "react";
import styled from "styled-components";

const Block = styled.div`
  color: white;
  margin-top: 30px;
  margin-bottom: -10px;

  p {
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 100%;
    text-align: center;
    letter-spacing: -0.01em;
    color: #ffffff;
  }

  &:hover {
    cursor: pointer;
  }

  span {
    margin-left: 8px;
  }

  @media (max-width: 1024px) {
    margin-top: 22px;
    margin-bottom: 0px;
  }

  @media (max-width: 768px) {
    margin-top: 17px;

    p {
      font-size: 15px;
    }
  }
`;

interface Props {
  display?: string;
  icon?: string;
  onClick?: () => void;
  firstClick?: boolean;
}

const Circle: React.FC<Props> = ({ display, icon, onClick, firstClick }) => {
  return (
    <Block onClick={() => onClick()}>
      <p>
        {display}
        <span>
          <img
            width="12"
            height="8"
            src={icon}
            alt="icon"
            // style={{ transform: "rotate(270deg)" }}
          />
        </span>
      </p>
    </Block>
  );
};

export default Circle;
